import { PeriodDto } from '@contract';

type ActionSortProps = {
  clockTimeTicks: number;
  createdAt: number;
  updatedAt: number;
  period: PeriodDto | null;
};

export function sortByActionTimes(a: ActionSortProps, b: ActionSortProps) {
  if (a.period && b.period && b.period.sequence > a.period.sequence) return 1;
  if (a.period && b.period && b.period.sequence < a.period.sequence) return -1;

  if (b.clockTimeTicks > a.clockTimeTicks) return 1;
  if (b.clockTimeTicks < a.clockTimeTicks) return -1;

  return b.createdAt - a.createdAt;
}

export function sortByCreatedAt(a: ActionSortProps, b: ActionSortProps) {
  return b.createdAt - a.createdAt;
}
export function sortByUpdatedAt(a: ActionSortProps, b: ActionSortProps) {
  return b.updatedAt - a.updatedAt;
}
